

const removeAllSeries = (chart) => {
  while (chart.series.length !== 0) {
    chart.series[0].remove()
  }
}



const createSeries = ({ name, data, color, id }) => {
  return {
    type: 'spline',
    id,
    name,
    visible: true,
    showInNavigator: true,
    data,
    color
  }
}


export {
  removeAllSeries,
  createSeries
}